var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useMemo, useRef } from 'react';
import React from 'react';
import { StyledTextField, StyledAutocomplete, SelectContainer, SelectLabel, ErrorText, StyledDropdownPaper, ButtonContainer, } from './styles';
import { ClearRounded } from '@material-ui/icons';
import { openedArrow } from '../../../assets/Images';
function ArrowButton() {
    return (React.createElement(ButtonContainer, null,
        React.createElement("img", { src: openedArrow })));
}
export default function SearchableSelect(_a) {
    var _b;
    var options = _a.options, value = _a.value, onChange = _a.onChange, _c = _a.clearable, clearable = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.placeholder, placeholder = _e === void 0 ? 'Seleccionar...' : _e, _f = _a.outlined, outlined = _f === void 0 ? true : _f, label = _a.label, error = _a.error, _g = _a.sortOptions, sortOptions = _g === void 0 ? false : _g;
    var inputRef = useRef(null);
    var optionsMap = useMemo(function () { return Object.fromEntries(options.map(function (option) { return [option.value, option]; })); }, [options]);
    var sortedOptions = useMemo(function () {
        return sortOptions
            ? __spreadArrays(options).sort(function (a, b) {
                return a.label.toString().localeCompare(b.label.toString());
            })
            : options;
    }, [options, sortOptions]);
    return (React.createElement(SelectContainer, null,
        label && React.createElement(SelectLabel, null, label),
        React.createElement(StyledAutocomplete, { popupIcon: React.createElement(ArrowButton, null), closeIcon: React.createElement(ClearRounded, null), PaperComponent: StyledDropdownPaper, openOnFocus: true, noOptionsText: "No hay opciones", value: value !== null ? (_b = optionsMap[value]) !== null && _b !== void 0 ? _b : null : null, options: sortedOptions, getOptionLabel: function (option) { return option.label.toString(); }, getOptionSelected: function (option, value) { return option.value === (value === null || value === void 0 ? void 0 : value.value); }, onChange: function (_, newValue) {
                var _a, _b, _c;
                (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
                onChange((_c = newValue === null || newValue === void 0 ? void 0 : newValue.value) !== null && _c !== void 0 ? _c : null);
            }, disableClearable: !clearable, renderInput: function (params) { return (React.createElement(StyledTextField, __assign({ variant: outlined ? 'outlined' : 'standard' }, params, { placeholder: placeholder, disabled: disabled, error: Boolean(error), inputRef: inputRef }))); }, disabled: disabled }),
        error && React.createElement(ErrorText, null, error)));
}
